import { defineComponent, watch } from 'vue'
import { isEqual } from 'lodash-es'
import { NInput, NInputNumber, NSelect } from 'naive-ui'
import { BlockPropsType } from '@/utils/types'
import useModel from '@/components/utils/useModel'
import { MultiColor, ColumnInput } from './components'

export default defineComponent({
  name: 'DynamicRender',
  props: {
    modelValue: {},
    field: {
      type: Object
    }
  },
  components: { ColumnInput, MultiColor, NInput, NInputNumber, NSelect },
  emits: ['update:modelValue'],
  setup(props, ctx) {
    const dataModel = useModel(() => ({
      [props.field.name]: props.modelValue
    }))

    const methods = {
      renderEditorItem: (fieldConfig) =>
        ({
          [BlockPropsType.input]: () => <n-input />,
          [BlockPropsType.number]: () => <n-input-number />,
          [BlockPropsType.textarea]: () => <n-input type="textarea" />,
          [BlockPropsType.color]: () => <n-color-picker modes={['rgb', 'hex']} />,
          [BlockPropsType.select]: () => <n-select options={fieldConfig.options} />,
          [BlockPropsType.switch]: () => <n-switch />,
          [BlockPropsType.multiColor]: () => <multi-color />,
          [BlockPropsType.columnInput]: () => <column-input />
        }[fieldConfig.type]()),
      onDataModelChange() {
        const newVal = dataModel.value[props.field.name]
        if (!isEqual(props.modelValue, newVal)) {
          ctx.emit('update:modelValue', newVal)
        }
      }
    }
    watch(() => dataModel.value, methods.onDataModelChange, { deep: true })
    return () => {
      const Component = methods.renderEditorItem(props.field)
      return <Component v-model={[dataModel.value[props.field.name], 'value']} />
    }
  }
})
